<script lang="ts" setup>
import CountryView from '@/components/country/view.vue'
import WorldView from '@/components/world/view.vue'

/**
 * Fetch all the necessary data. Fetch the meta and countries first,
 * to let the system know which are the available countries and which
 * are "meta" dimensions. Then fetch the tiles and the framework.
 */
await Promise.all([useMeta().fetch(), useCountries().fetch()])
await Promise.all([useTiles().fetch(), useFramework().fetch()])

/**
 * Use the current parameters.
 */
const { config } = useParams()
</script>
    
<template>
    <component :is="config.country ? CountryView : WorldView" />
</template>